import * as React from "react";
const SvgFiRrClapperboardPlay = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M19 1H5C2.243 1 0 3.243 0 6v12c0 2.757 2.243 5 5 5h14c2.757 0 5-2.243 5-5V6c0-2.757-2.243-5-5-5m3 6h-3.894l3.066-3.066A3 3 0 0 1 22 6zm-2.734-3.988-3.973 3.973-.014.015h-3.423l4-4H19q.135 0 .266.012M13.028 3 9.264 6.764A1 1 0 0 0 9.089 7H5.606l4-4zM5 3h1.778l-4 4H2V6c0-1.654 1.346-3 3-3m14 18H5c-1.654 0-3-1.346-3-3V9h20v9c0 1.654-1.346 3-3 3m-3.953-5.2-4.634 2.48A.933.933 0 0 1 9 17.48v-4.961a.933.933 0 0 1 1.413-.8l4.634 2.48a.933.933 0 0 1 0 1.6z"
    />
  </svg>
);
export default SvgFiRrClapperboardPlay;
